import { render, staticRenderFns } from "./QueueDetail.vue?vue&type=template&id=8573724a&scoped=true&"
import script from "./QueueDetail.vue?vue&type=script&lang=js&"
export * from "./QueueDetail.vue?vue&type=script&lang=js&"
import style0 from "./QueueDetail.vue?vue&type=style&index=0&id=8573724a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8573724a",
  null
  
)

export default component.exports